import './Support.css';

const SUPPORT_EMAIL = 'support@zopeo.in';

const Support = () => (
  <section className="section support-page">
    <div className="section-header">
      <h2>Support</h2>
      <p>Need help? Reach us anytime.</p>
    </div>

    <div className="card support-card">
      <h3>Contact</h3>
      <p className="support-copy">
        Email us at{' '}
        <a className="support-link" href={`mailto:${SUPPORT_EMAIL}`}>
          {SUPPORT_EMAIL}
        </a>
        .
      </p>
      <p className="support-muted">
        Please include your store code and a brief description of the issue so we can help faster.
      </p>
    </div>
  </section>
);

export default Support;

